export default __webpack_public_path__ + "static/media/10.1a8442ee.jpg";